export default __webpack_public_path__ + "static/media/DSC_9512.302cca16.jpg";